function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.959 3.744h-.929v-2.54C11.03.54 10.49 0 9.827 0H6.584c-.663 0-1.203.54-1.203 1.203v2.541h-.93c-.8 0-1.451.652-1.451 1.452v7.934c0 .712.515 1.304 1.192 1.427v.788c0 .361.294.655.655.655h1.201a.656.656 0 00.656-.655v-.763h3.003v.763c0 .361.294.655.655.655h1.202a.656.656 0 00.655-.655v-.788a1.453 1.453 0 001.192-1.427V5.196c0-.8-.652-1.452-1.452-1.452zm-5.776-2.54c0-.222.18-.402.401-.402h3.243c.22 0 .4.18.4.401v2.541H6.184v-2.54zm-.282 13.994h-.907v-.616H5.9v.616zm4.608 0v-.616h.908v.616h-.908zm2.1-2.068a.65.65 0 01-.65.65H4.452a.65.65 0 01-.65-.65V5.196a.65.65 0 01.65-.65h7.507a.65.65 0 01.65.65v7.934z",
  fill: "#F9253F"
}));